var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisableDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#EDEFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H14.5V22H13V13ZM17.5 13H19V22H17.5V13Z",
    fill: "#96A0BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5V10H8.5V25C8.5 25.3978 8.65804 25.7794 8.93934 26.0607C9.22064 26.342 9.60218 26.5 10 26.5H22C22.3978 26.5 22.7794 26.342 23.0607 26.0607C23.342 25.7794 23.5 25.3978 23.5 25V10H25V8.5H7ZM10 25V10H22V25H10ZM13 5.5H19V7H13V5.5Z",
    fill: "#96A0BC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableDelete);
export default __webpack_public_path__ + "static/media/disableDelete.32b6eb1c9869c8ebcddcad1dae5215b2.svg";
export { ForwardRef as ReactComponent };